<template>
    <transition
        appear
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
    >
        <div class="banner-container bg-input-color" v-if="display">
            <div class="constrain-sm">
                <q-banner dense inline-actions class="bg-input-color text-white install">
                    <q-avatar color="white" icon="my:r-p" text-color="primary" size="30px" class="q-mr-sm"/>

                    <span>{{$t('install_dialog.install_rebit_app')}}</span>

                    <template v-slot:action>
                        <q-btn dense flat :label="$t('install_dialog.yes')" class="q-px-xs q-mx-xs" @click="installApp"/>
                        <q-btn dense flat :label="$t('install_dialog.later')" class="q-px-xs q-mx-xs" @click="display = false"/>
                        <q-btn dense flat :label="$t('install_dialog.never')" class="q-px-xs q-mx-xs" @click="neverShowAppInstallBanner"/>
                    </template>
                </q-banner>
            </div>
        </div>
    </transition>
</template>
<script>

// Initialize deferredPrompt for use later to show browser install prompt.
let deferredPrompt;

export default {
    name: "InstallNotification",
    props: {},
    computed: {},
    data() {
        return {
            display: false
        }
    },
    methods: {
        async installApp() {
            this.display = false
            deferredPrompt.prompt()
            const {outcome} = await deferredPrompt.userChoice
            if (outcome === 'accepted') {
                this.neverShowAppInstallBanner()
            }
            deferredPrompt = null;
        },
        neverShowAppInstallBanner() {
            this.display = false
            this.$q.localStorage.set("neverShowAppInstallBanner", true)
        }
    },
    created() {
    },
    mounted() {
        let neverShowAppInstallBanner = this.$q.localStorage.getItem("neverShowAppInstallBanner")
        if (!neverShowAppInstallBanner) {
            window.addEventListener('beforeinstallprompt', (e) => {
                e.preventDefault()
                deferredPrompt = e
                setTimeout(() => {
                    this.display = true
                }, 500)
            })
        }

    },
    watch: {},
    components: {},
}
</script>
<style>
.install.q-banner--dense .q-banner__actions.col-auto {
    padding: 0;
}
</style>
